require('./vendor/bootstrap.js');

require('./submit');

if($("#app").length) {
    require('./vendor/vue.js');
}

if ($('.datepicker-start-today').length) {
    require('./vendor/datepicker_start_today');
}

if ($('.datepicker-placement-date').length) {
    require('./vendor/datepicker_placement_date');
}

if ($('.datepicker').length) {
    require('./vendor/datepicker');
}

require('./vendor/error_handling');
require('./vendor/toggle_state.js');
require('./vendor/identify_browsertabs.js');
require('./main');